import axios from "./api"

const favoritesApi = {
    checkFavorites(data) {
        return axios.post(`/api/favorites/check`, data);
    },
    postFavoriteCreature(data) {
        const creatureId = data.creature_id;
        return axios.post(`/api/creatures/${creatureId}/favorite`, data);
    },
    deleteFavoriteCreature(data) {
        const creatureId = data.creature_id;
        return axios.delete(`/api/creatures/${creatureId}/favorite`, data);
    },
    getFavoritesList(data) {
        const resultLimit = data.result_limit;
        const rangeStart = data.range_start;
        return axios.get(`/api/favorites/list?result_limit=${resultLimit}&range_start=${rangeStart}`);
    }
}

export default favoritesApi;
